/**
 * CMS 组件配置 router => [keys...]
 *  keys为不含语言的前缀部分
 */
export const CmsComponents = {
  /** 通用 */
  _: ['com.newheader.logo', 'com.newFooter.links', 'com.newFooter.copyright'],
  // 新版才用cdn 加载，将上面的几个组合成 com.commons
  combine: ['com.newheader.logo.new', 'com.newFooter.links.new', 'com.newFooter.copyright.new'],
};

// 默认语言
export const DEFAULT_LANG = 'en_US';

export const getCmsCdnHost = () => {
  // 如果存在服务端渲染，那么直接走线上
  try {
    if (!window) {
      return 'https://assets.staticimg.com/cms-static';
    }
    const { origin } = window.location;
    const isDevOrQA = origin.indexOf('net') > -1 || origin.indexOf('localhost') > -1;
    // 开发或qa 走测试环境
    if (isDevOrQA) {
      return 'https://assets-v2.kucoin.net/cms-static';
    }
    return 'https://assets.staticimg.com/cms-static';
  } catch (e) {
    return 'https://assets.staticimg.com/cms-static';
  }
};
